import { t } from "../../i18n";
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Card, CardContent, CardHeader, Divider, Typography } from '@mui/material';

// constant
const headerSX = {
  '& .MuiCardHeader-action': {
    mr: 0
  }
};

// ==============================|| CUSTOM MAIN CARD ||============================== //

const MainCard = forwardRef(({
  border = true,
  boxShadow,
  children,
  color,
  content = true,
  contentClass = '',
  contentSX = {},
  darkTitle,
  secondary,
  shadow,
  sx = {},
  title,
  ...others
}, ref) => {
  const theme = useTheme();
  return <Card ref={ref} {...others} sx={{
    p: 2,
    border: border ? '1px solid' : 'none',
    borderColor: theme.palette.primary[200] + 75,
    ':hover': {
      boxShadow: boxShadow ? shadow || '0 2px 14px 0 rgb(32 40 45 / 8%)' : 'inherit'
    },
    ...sx
  }}>
                {/* card header and action */}
                {!darkTitle && t(title) && <CardHeader sx={headerSX} title={<span style={{
      color: color
    }}>{t(title)}</span>} action={secondary} />}
                {darkTitle && t(title) && <CardHeader sx={headerSX} title={<Typography variant="h6">{t(title)}</Typography>} action={secondary} />}

                {/* content & header divider */}
                {t(title) && <Divider />}

                {/* card content */}
                {content && <CardContent sx={contentSX} className={contentClass}>
                        {children}
                    </CardContent>}
                {!content && children}
            </Card>;
});
MainCard.displayName = 'MainCard';
MainCard.propTypes = {
  border: PropTypes.bool,
  boxShadow: PropTypes.bool,
  children: PropTypes.node,
  color: PropTypes.string,
  content: PropTypes.bool,
  contentClass: PropTypes.string,
  contentSX: PropTypes.object,
  darkTitle: PropTypes.bool,
  secondary: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object]),
  shadow: PropTypes.string,
  sx: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object])
};
export default MainCard;
